export { default as ChannelList } from './ChannelList';
export { default as ChannelEdit } from './ChannelEdit';
export { default as WarehouseCodes } from './WarehouseCodes';
export { default as CustomLabel } from './CustomLabel';
export { default as AmazonTemplates } from './AmazonTemplates';



// WEBPACK FOOTER //
// ./src/modules/channel/pages/index.js